import request from '@/config'
import { CatRulesSearch, DeleteRuleDto, CatRulesBase } from './dtos';

enum Apis {
    List = '/api/basiccatrules/getpagelist',
    Delete = '/api/basiccatrules/deletion',
    Creation = '/api/basiccatrules/create',
    Modify = '/api/basiccatrules/modify',
    Detail = '/api/basiccatrules/getdetail',
    DeptMembers = `/api/basiccatrules/getdeptauditmembers`
}

const GetCatRuleListApi = (search: CatRulesSearch): Promise<IResponse> => {
    return request.post({ url: Apis.List, data: search })
}

const DelCatRuleListApi = (input: DeleteRuleDto): Promise<IResponse> => {
    return request.post({ url: Apis.Delete, data: input })
}

const CatRuleCreateApi = (input: CatRulesBase): Promise<IResponse> => {
    return request.post({ url: Apis.Creation, data: input })
}

const CatRuleEditApi = (input: CatRulesBase): Promise<IResponse> => {
    return request.post({ url: Apis.Modify, data: input })
}

const GetRuleInfoApi = (rowId: string): Promise<IResponse> => {
    return request.post({ url: Apis.Detail, data: { id: rowId } })
}

const GetDeptAuditMenbersApi = (): Promise<IResponse> => {
    return request.post({ url: Apis.DeptMembers, data: {} })
}

export {
    GetCatRuleListApi,
    DelCatRuleListApi,
    CatRuleCreateApi,
    CatRuleEditApi,
    GetRuleInfoApi,
    GetDeptAuditMenbersApi,
}